import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const FrequentFlyerIcon = _ref => {
  let {
      size = "20",
      color
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx("path", {
    d: "M7.3125 3.375C7.3125 2.25 7.875 0.5625 9 0.5625C10.125 0.5625 10.6875 2.25 10.6875 3.375L10.6875 7.875L16.8847 10.9736C17.2235 11.143 17.4375 11.4893 17.4375 11.868V13.5L10.6875 12.375L10.125 15.75L11.8125 17.4375L6.1875 17.4375L7.875 15.75L7.3125 12.375L0.5625 13.5L0.5625 11.868C0.5625 11.4893 0.776503 11.143 1.11529 10.9736L7.3125 7.875V3.375Z",
    fill: color ? color : "#00475B"
  }));
};
export default FrequentFlyerIcon;